import type { Skill } from '../skillsData';

export const cryptoskillAnalyticsExtraAData: Skill[] = [
  {
    id: '8004kenzo-analytics',
    name: '8004kenzo-analytics',
    author: '8004 Protocol',
    authorHandle: '@8004protocol',
    tag: 'Skill',
    category: 'analytics',
    description: '8004 protocol analytics. On-chain agent identity metrics, reputation scoring dashboards, and ERC-8004 registry analytics.',
    downloads: 4200,
    stars: 210,
    version: '1.0.0',
    installCommand: '> install the 8004kenzo-analytics skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/8004kenzo-analytics',
    usageExample: '> query 8004 metrics\n> check agent reputation\n> monitor registry stats',
    detailedDescription: 'Analytics toolkit for the 8004 protocol agent identity and reputation system. Query on-chain identity metrics, monitor ERC-8004 registry statistics, and build reputation scoring dashboards.',
  },
  {
    id: '8004kenzo',
    name: '8004kenzo',
    author: '8004 Protocol',
    authorHandle: '@8004protocol',
    tag: 'Skill',
    category: 'analytics',
    description: '8004 protocol core analytics engine. Data aggregation, on-chain event indexing, and agent behavior analysis for the 8004 ecosystem.',
    downloads: 3800,
    stars: 190,
    version: '1.0.0',
    installCommand: '> install the 8004kenzo skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/8004kenzo',
    usageExample: '> aggregate 8004 data\n> index on-chain events\n> analyze agent behavior',
    detailedDescription: 'Core analytics engine for 8004 protocol providing on-chain event indexing, agent behavior pattern analysis, and data aggregation services for the decentralized identity ecosystem.',
  },
  {
    id: 'aelfscan-official-skill',
    name: 'aelfscan-official-skill',
    author: 'aelf',
    authorHandle: '@aelfblockchain',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official aelfscan explorer skill. Query aelf blockchain transactions, blocks, contracts, and token data via the aelfscan API.',
    downloads: 5600,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the aelfscan-official-skill skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aelfscan-official-skill',
    usageExample: '> query aelf tx\n> get block data\n> check contract state',
    detailedDescription: 'Official aelfscan block explorer integration for the aelf blockchain. Query transactions, blocks, smart contracts, and token metadata with full aelfscan API coverage.',
  },
  {
    id: 'agentic-eye',
    name: 'agentic-eye',
    author: 'Agentic Eye',
    authorHandle: '@agentic_eye',
    tag: 'Skill',
    category: 'analytics',
    description: 'Agentic Eye on-chain monitoring. Real-time AI agent activity tracking, smart contract interaction auditing, and autonomous system surveillance.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the agentic-eye skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/agentic-eye',
    usageExample: '> monitor agent activity\n> audit contract interactions\n> track autonomous systems',
    detailedDescription: 'Agentic Eye surveillance system for monitoring AI agent on-chain activities. Track smart contract interactions, audit autonomous system behaviors, and receive real-time alerts for anomalous agent actions.',
  },
  {
    id: 'agentic-eye-content',
    name: 'agentic-eye-content',
    author: 'Agentic Eye',
    authorHandle: '@agentic_eye',
    tag: 'Skill',
    category: 'analytics',
    description: 'Agentic Eye content intelligence. Analyze AI-generated content on-chain, verify provenance, and track content distribution patterns.',
    downloads: 4800,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the agentic-eye-content skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/agentic-eye-content',
    usageExample: '> analyze AI content\n> verify content provenance\n> track distribution',
    detailedDescription: 'Content intelligence module for Agentic Eye. Analyze AI-generated on-chain content, verify content provenance through cryptographic signatures, and track distribution patterns across decentralized networks.',
  },
  {
    id: 'agentic-eye-content-intelligence',
    name: 'agentic-eye-content-intelligence',
    author: 'Agentic Eye',
    authorHandle: '@agentic_eye',
    tag: 'Skill',
    category: 'analytics',
    description: 'Advanced content intelligence for Agentic Eye. Deep content analysis, sentiment extraction, and semantic similarity detection for on-chain media.',
    downloads: 3400,
    stars: 170,
    version: '1.0.0',
    installCommand: '> install the agentic-eye-content-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/agentic-eye-content-intelligence',
    usageExample: '> deep content analysis\n> extract sentiment\n> detect semantic similarity',
    detailedDescription: 'Advanced content intelligence platform providing deep analysis of on-chain media. Extract sentiment, detect semantic similarities between content pieces, and generate comprehensive content quality reports.',
  },
  {
    id: 'aicoin-official-coinos-skills',
    name: 'aicoin-official-coinos-skills',
    author: 'AICoin',
    authorHandle: '@aicoin',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official AICoin CoinOS skills. Market data aggregation, token analytics, and AI-powered market prediction for the CoinOS ecosystem.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the aicoin-official-coinos-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aicoin-official-coinos-skills',
    usageExample: '> aggregate market data\n> analyze token metrics\n> get AI prediction',
    detailedDescription: 'Official AICoin CoinOS integration providing comprehensive market data aggregation, real-time token analytics, and AI-powered market prediction models for informed trading decisions.',
  },
  {
    id: 'aixbt',
    name: 'aixbt',
    author: 'aixbt',
    authorHandle: '@aixbt',
    tag: 'Skill',
    category: 'analytics',
    description: 'aixbt AI crypto analyst. On-chain intelligence, whale tracking, and smart money flow analysis powered by machine learning.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the aixbt skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aixbt',
    usageExample: '> get on-chain intel\n> track whale wallets\n> analyze smart money flow',
    detailedDescription: 'aixbt AI-powered crypto analytics platform. Machine learning-driven on-chain intelligence, real-time whale wallet tracking, and smart money flow analysis for alpha generation.',
    trending: true,
  },
  {
    id: 'arthur-mcp-server',
    name: 'arthur-mcp-server',
    author: 'Arthur Protocol',
    authorHandle: '@arthurprotocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'Arthur MCP analytics server. Model Context Protocol interface for accessing Arthur Protocol on-chain data, metrics, and governance analytics.',
    downloads: 3800,
    stars: 190,
    version: '1.0.0',
    installCommand: '> install the arthur-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/arthur-mcp-server',
    usageExample: '> query Arthur data via MCP\n> get protocol metrics\n> analyze governance',
    detailedDescription: 'Arthur Protocol Model Context Protocol server exposing on-chain analytics, protocol performance metrics, treasury data, and governance participation statistics via standardized MCP interfaces.',
  },
  {
    id: 'ask-heurist-agent',
    name: 'ask-heurist-agent',
    author: 'Heurist AI',
    authorHandle: '@heurist_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Ask Heurist analytics agent. Natural language queries for on-chain data analysis, market research, and DeFi protocol intelligence via Heurist AI.',
    downloads: 9600,
    stars: 480,
    version: '1.0.0',
    installCommand: '> install the ask-heurist-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/ask-heurist-agent',
    usageExample: '> ask heurist about market\n> query DeFi intelligence\n> research protocol',
    detailedDescription: 'Heurist AI-powered analytics agent enabling natural language queries for on-chain data analysis. Ask questions about market trends, DeFi protocol metrics, and receive intelligent research summaries.',
  },
  {
    id: 'aura-sight-nft',
    name: 'aura-sight-nft',
    author: 'AuraSight',
    authorHandle: '@aurasight',
    tag: 'Skill',
    category: 'analytics',
    description: 'AuraSight NFT analytics. Collection metrics, holder behavior analysis, floor price tracking, and rarity scoring across major NFT marketplaces.',
    downloads: 5800,
    stars: 290,
    version: '1.0.0',
    installCommand: '> install the aura-sight-nft skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aura-sight-nft',
    usageExample: '> analyze NFT collection\n> track holder behavior\n> monitor floor price',
    detailedDescription: 'AuraSight NFT analytics platform providing collection performance metrics, detailed holder behavior analysis, real-time floor price tracking, and automated rarity scoring across OpenSea, Blur, and LooksRare.',
  },
  {
    id: 'aurasight',
    name: 'aurasight',
    author: 'AuraSight',
    authorHandle: '@aurasight',
    tag: 'Skill',
    category: 'analytics',
    description: 'AuraSight core analytics. On-chain entity labeling, wallet clustering, transaction graph analysis, and behavioral pattern recognition.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the aurasight skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aurasight',
    usageExample: '> label on-chain entities\n> cluster wallets\n> analyze tx graphs',
    detailedDescription: 'AuraSight core on-chain intelligence platform. Automatically label blockchain entities, cluster related wallets, analyze transaction graphs, and recognize behavioral patterns for comprehensive address intelligence.',
  },
  {
    id: 'aurasight-nft',
    name: 'aurasight-nft',
    author: 'AuraSight',
    authorHandle: '@aurasight',
    tag: 'Skill',
    category: 'analytics',
    description: 'AuraSight NFT core. NFT ownership tracking, transfer history analysis, and market sentiment indicators for digital collectibles.',
    downloads: 4600,
    stars: 230,
    version: '1.0.0',
    installCommand: '> install the aurasight-nft skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aurasight-nft',
    usageExample: '> track NFT ownership\n> analyze transfer history\n> check market sentiment',
    detailedDescription: 'AuraSight NFT analytics core module. Track ownership changes, analyze historical transfer patterns, and measure market sentiment indicators for NFT collections and individual tokens.',
  },
  {
    id: 'aurasight-nft-analytics',
    name: 'aurasight-nft-analytics',
    author: 'AuraSight',
    authorHandle: '@aurasight',
    tag: 'Skill',
    category: 'analytics',
    description: 'AuraSight NFT advanced analytics. Wash trading detection, volume manipulation alerts, and smart money NFT flow tracking.',
    downloads: 4200,
    stars: 210,
    version: '1.0.0',
    installCommand: '> install the aurasight-nft-analytics skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/aurasight-nft-analytics',
    usageExample: '> detect wash trading\n> alert on volume manipulation\n> track smart NFT flow',
    detailedDescription: 'Advanced NFT analytics from AuraSight featuring wash trading detection algorithms, volume manipulation alerts, and smart money flow tracking into and out of NFT collections.',
  },
  {
    id: 'bicscan-mcp',
    name: 'bicscan-mcp',
    author: 'BICScan',
    authorHandle: '@bicscan',
    tag: 'Skill',
    category: 'analytics',
    description: 'BICScan MCP server. Model Context Protocol for blockchain explorer data access, transaction lookup, and address analytics.',
    downloads: 3400,
    stars: 170,
    version: '1.0.0',
    installCommand: '> install the bicscan-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/bicscan-mcp',
    usageExample: '> query BICScan via MCP\n> lookup transactions\n> analyze address',
    detailedDescription: 'BICScan Model Context Protocol server providing standardized access to blockchain explorer data, transaction lookups, address analytics, and smart contract verification via MCP interfaces.',
  },
  {
    id: 'billionsx-ai',
    name: 'billionsx-ai',
    author: 'BillionsX',
    authorHandle: '@billionsx_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'BillionsX AI analytics platform. Institutional-grade market intelligence, portfolio analytics, and risk management for crypto assets.',
    downloads: 6200,
    stars: 310,
    version: '1.0.0',
    installCommand: '> install the billionsx-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/billionsx-ai',
    usageExample: '> get market intelligence\n> analyze portfolio risk\n> generate risk report',
    detailedDescription: 'BillionsX AI-powered institutional analytics platform. Access market intelligence feeds, perform comprehensive portfolio risk analysis, and generate institutional-grade risk management reports.',
  },
  {
    id: 'chainlink-mcp-server',
    name: 'chainlink-mcp-server',
    author: 'Chainlink',
    authorHandle: '@chainlink',
    tag: 'Skill',
    category: 'analytics',
    description: 'Chainlink MCP analytics server. Access price feeds, Proof of Reserve, CCIP metrics, and VRF data via Model Context Protocol.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the chainlink-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/chainlink-mcp-server',
    usageExample: '> query Chainlink via MCP\n> get price feed data\n> check Proof of Reserve',
    detailedDescription: 'Official Chainlink Model Context Protocol server. Query price feeds, Proof of Reserve attestations, CCIP cross-chain metrics, and VRF randomness data through standardized MCP endpoints.',
    featured: true,
  },
  {
    id: 'cmc-api-crypto',
    name: 'cmc-api-crypto',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap Crypto API. Access cryptocurrency listings, market pairs, quotes, and global metrics via the official CMC API.',
    downloads: 38400,
    stars: 1920,
    version: '1.0.0',
    installCommand: '> install the cmc-api-crypto skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-api-crypto',
    usageExample: '> get CMC listings\n> query crypto quotes\n> check global metrics',
    detailedDescription: 'CoinMarketCap official crypto data API integration. Access comprehensive cryptocurrency listings, real-time and historical quotes, market pairs data, and global crypto market metrics.',
    featured: true,
  },
  {
    id: 'cmc-api-dex',
    name: 'cmc-api-dex',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap DEX API. Decentralized exchange data, DEX pair analytics, liquidity metrics, and trading volume from CMC DEX endpoints.',
    downloads: 24600,
    stars: 1230,
    version: '1.0.0',
    installCommand: '> install the cmc-api-dex skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-api-dex',
    usageExample: '> get DEX pairs\n> analyze DEX liquidity\n> check DEX volume',
    detailedDescription: 'CoinMarketCap DEX data API providing decentralized exchange analytics, DEX pair listings, liquidity depth metrics, and comprehensive trading volume data across major DEX protocols.',
  },
  {
    id: 'cmc-api-exchange',
    name: 'cmc-api-exchange',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap Exchange API. CEX rankings, exchange volume data, market pairs per exchange, and fiat on/off-ramp analytics.',
    downloads: 26800,
    stars: 1340,
    version: '1.0.0',
    installCommand: '> install the cmc-api-exchange skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-api-exchange',
    usageExample: '> get exchange rankings\n> query exchange volume\n> analyze fiat ramps',
    detailedDescription: 'CoinMarketCap centralized exchange analytics API. Access exchange rankings, trading volume data, market pairs per platform, and fiat on/off-ramp analytics for comprehensive CEX intelligence.',
  },
  {
    id: 'cmc-api-market',
    name: 'cmc-api-market',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap Market API. Global market overview, dominance charts, historical snapshots, and market sentiment indicators.',
    downloads: 31200,
    stars: 1560,
    version: '1.0.0',
    installCommand: '> install the cmc-api-market skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-api-market',
    usageExample: '> get market overview\n> check dominance charts\n> view historical snapshot',
    detailedDescription: 'CoinMarketCap global market analytics API. Retrieve comprehensive market overviews, BTC/ETH dominance charts, historical market snapshots, and real-time market sentiment indicators.',
    featured: true,
  },
  {
    id: 'cmc-api-onchain',
    name: 'cmc-api-onchain',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap On-Chain API. Blockchain analytics, active addresses, transaction counts, and network value metrics from CMC on-chain endpoints.',
    downloads: 22400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the cmc-api-onchain skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-api-onchain',
    usageExample: '> get on-chain metrics\n> count active addresses\n> check network value',
    detailedDescription: 'CoinMarketCap on-chain analytics API providing blockchain network metrics, active address counts, transaction volume data, and network value indicators across supported chains.',
  },
  {
    id: 'cmc-mcp',
    name: 'cmc-mcp',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap MCP server. Full CMC data access via Model Context Protocol for AI agent market research and portfolio analysis.',
    downloads: 15600,
    stars: 780,
    version: '1.0.0',
    installCommand: '> install the cmc-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/cmc-mcp',
    usageExample: '> query CMC via MCP\n> research market data\n> analyze portfolio',
    detailedDescription: 'CoinMarketCap Model Context Protocol server exposing the complete CMC API suite through standardized MCP interfaces for seamless AI agent market research and portfolio analytics.',
    trending: true,
  },
  {
    id: 'coingecko-price',
    name: 'coingecko-price',
    author: 'CoinGecko',
    authorHandle: '@coingecko',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinGecko price-focused API. Real-time prices, price changes, market caps, and historical price data for 15,000+ cryptocurrencies.',
    downloads: 48600,
    stars: 2430,
    version: '1.0.0',
    installCommand: '> install the coingecko-price skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/coingecko-price',
    usageExample: '> get real-time prices\n> check price changes\n> query historical price',
    detailedDescription: 'CoinGecko price-centric API integration. Access real-time cryptocurrency prices, 24h/7d/30d price changes, market capitalization data, and extensive historical price charts for 15,000+ coins.',
    featured: true,
  },
  {
    id: 'compass-rose-protocol',
    name: 'compass-rose-protocol',
    author: 'Compass Rose',
    authorHandle: '@compassrose',
    tag: 'Skill',
    category: 'analytics',
    description: 'Compass Rose Protocol analytics. Decentralized data oracle analytics, consensus metrics, and node performance tracking for the Compass Rose network.',
    downloads: 3200,
    stars: 160,
    version: '1.0.0',
    installCommand: '> install the compass-rose-protocol skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/compass-rose-protocol',
    usageExample: '> query oracle data\n> check consensus metrics\n> track node performance',
    detailedDescription: 'Compass Rose Protocol decentralized oracle analytics. Monitor data feed accuracy, track consensus participation metrics, and analyze node operator performance across the oracle network.',
  },
  {
    id: 'credora-ratings',
    name: 'credora-ratings',
    author: 'Credora',
    authorHandle: '@credora_io',
    tag: 'Skill',
    category: 'analytics',
    description: 'Credora credit ratings for DeFi. On-chain credit scoring, protocol risk ratings, and institutional DeFi risk analytics.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the credora-ratings skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/credora-ratings',
    usageExample: '> get credit score\n> check protocol risk\n> analyze DeFi risk',
    detailedDescription: 'Credora institutional DeFi credit rating platform. Access on-chain credit scores for borrowers, protocol risk ratings based on smart contract and liquidity analysis, and comprehensive DeFi risk analytics.',
  },
  {
    id: 'crypto-intel-github-analytics',
    name: 'crypto-intel-github-analytics',
    author: 'Crypto Intel',
    authorHandle: '@cryptointel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intel GitHub analytics. Track developer activity, code commits, repository health, and open-source project intelligence for crypto protocols.',
    downloads: 5600,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the crypto-intel-github-analytics skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intel-github-analytics',
    usageExample: '> track dev activity\n> analyze repo health\n> get OSS intelligence',
    detailedDescription: 'Crypto Intel GitHub integration tracking open-source development metrics. Monitor code commit velocity, contributor activity, repository health scores, and developer engagement for crypto protocols.',
  },
  {
    id: 'crypto-intel-research',
    name: 'crypto-intel-research',
    author: 'Crypto Intel',
    authorHandle: '@cryptointel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intel research platform. Deep-dive protocol research, tokenomics analysis, and fundamental valuation models for digital assets.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the crypto-intel-research skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intel-research',
    usageExample: '> research protocol\n> analyze tokenomics\n> run valuation model',
    detailedDescription: 'Crypto Intel comprehensive research platform. Perform deep-dive protocol analysis, evaluate tokenomics design, and apply fundamental valuation models including DCF, FDV/TVL ratios, and comparative analysis.',
  },
  {
    id: 'crypto-intel-security',
    name: 'crypto-intel-security',
    author: 'Crypto Intel',
    authorHandle: '@cryptointel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intel security intelligence. Smart contract vulnerability tracking, exploit monitoring, and security incident alerting for DeFi protocols.',
    downloads: 8400,
    stars: 420,
    version: '1.0.0',
    installCommand: '> install the crypto-intel-security skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intel-security',
    usageExample: '> track vulnerabilities\n> monitor exploits\n> set security alerts',
    detailedDescription: 'Crypto Intel security intelligence module. Track smart contract vulnerabilities across DeFi protocols, monitor real-time exploit incidents, and receive automated security alerts with impact assessment.',
  },
  {
    id: 'crypto-intel-suite',
    name: 'crypto-intel-suite',
    author: 'Crypto Intel',
    authorHandle: '@cryptointel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intel complete suite. All-in-one intelligence platform combining market data, on-chain analytics, research, and security monitoring.',
    downloads: 9200,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the crypto-intel-suite skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intel-suite',
    usageExample: '> access full intel suite\n> run comprehensive analysis\n> get unified dashboard',
    detailedDescription: 'Complete Crypto Intel suite combining all analytics modules. Access unified market data, on-chain intelligence, protocol research, and security monitoring through a single integrated interface.',
  },
  {
    id: 'crypto-intelligence-suite',
    name: 'crypto-intelligence-suite',
    author: 'Crypto Intelligence',
    authorHandle: '@cryptointelhq',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intelligence Suite. Multi-source intelligence aggregation combining on-chain, off-chain, social, and news data into unified market signals.',
    downloads: 7600,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the crypto-intelligence-suite skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intelligence-suite',
    usageExample: '> aggregate multi-source intel\n> generate market signals\n> build unified dashboard',
    detailedDescription: 'Comprehensive crypto intelligence aggregation platform. Combine on-chain metrics, off-chain data, social sentiment, and news analysis into unified market signals and actionable trading insights.',
  },
  {
    id: 'crypto-liquidations-mcp',
    name: 'crypto-liquidations-mcp',
    author: 'Liquidations Watch',
    authorHandle: '@liqwatch',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto liquidations MCP server. Real-time liquidation data, leverage analytics, and cascading liquidation risk alerts via Model Context Protocol.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the crypto-liquidations-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-liquidations-mcp',
    usageExample: '> query liquidations via MCP\n> get leverage analytics\n> set cascade alerts',
    detailedDescription: 'Real-time cryptocurrency liquidations monitoring via Model Context Protocol. Track liquidation events across major exchanges, analyze leverage ratios, and receive cascading liquidation risk alerts.',
    trending: true,
  },
  {
    id: 'crypto-project-scanner',
    name: 'crypto-project-scanner',
    author: 'Project Scanner',
    authorHandle: '@projscanner',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto project scanner. Automated project evaluation, red flag detection, and due diligence reports for new token launches and DeFi protocols.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the crypto-project-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-project-scanner',
    usageExample: '> scan new project\n> detect red flags\n> generate due diligence',
    detailedDescription: 'Automated cryptocurrency project evaluation scanner. Detect red flags in token contracts, analyze team backgrounds, evaluate tokenomics health, and generate comprehensive due diligence reports.',
  },
  {
    id: 'crypto-research',
    name: 'crypto-research',
    author: 'Crypto Research',
    authorHandle: '@cryptoresearch',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto research toolkit. Protocol analysis, competitive landscape mapping, and investment thesis generation for digital asset research.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the crypto-research skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-research',
    usageExample: '> analyze protocol\n> map competitive landscape\n> generate thesis',
    detailedDescription: 'Comprehensive crypto research toolkit for protocol analysis. Map competitive landscapes, evaluate technology stacks, assess market positioning, and generate structured investment theses.',
  },
  {
    id: 'crypto-sentiment-mcp',
    name: 'crypto-sentiment-mcp',
    author: 'Sentiment Labs',
    authorHandle: '@sentimentlabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto sentiment MCP server. Social sentiment analysis, Twitter/X trends, Reddit metrics, and market emotion tracking via Model Context Protocol.',
    downloads: 9800,
    stars: 490,
    version: '1.0.0',
    installCommand: '> install the crypto-sentiment-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-sentiment-mcp',
    usageExample: '> query sentiment via MCP\n> analyze Twitter trends\n> track market emotion',
    detailedDescription: 'Cryptocurrency sentiment analysis MCP server. Aggregate social media sentiment from Twitter/X, Reddit, and Telegram, track market emotion indicators, and correlate sentiment shifts with price movements.',
  },
  {
    id: 'data-analyst-pro',
    name: 'data-analyst-pro',
    author: 'Data Analyst Pro',
    authorHandle: '@dataanalystpro',
    tag: 'Skill',
    category: 'analytics',
    description: 'Data Analyst Pro for crypto. Advanced statistical analysis, time-series modeling, and predictive analytics for blockchain data.',
    downloads: 10200,
    stars: 510,
    version: '1.0.0',
    installCommand: '> install the data-analyst-pro skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/data-analyst-pro',
    usageExample: '> run statistical analysis\n> build time-series model\n> generate predictions',
    detailedDescription: 'Professional data analytics toolkit for cryptocurrency markets. Perform advanced statistical analysis, build ARIMA/GARCH time-series models, and generate predictive analytics for blockchain datasets.',
  },
  {
    id: 'defillama-api',
    name: 'defillama-api',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama API core. Direct access to DeFiLlama data endpoints for TVL, yields, volumes, and protocol metrics across all tracked chains.',
    downloads: 42600,
    stars: 2130,
    version: '1.0.0',
    installCommand: '> install the defillama-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-api',
    usageExample: '> query DefiLlama API\n> get TVL data\n> fetch protocol metrics',
    detailedDescription: 'Direct DefiLlama API integration providing access to TVL rankings, yield data, DEX volumes, protocol metrics, chain statistics, and stablecoin data across all tracked blockchain networks.',
    featured: true,
  },
  {
    id: 'defillama-data',
    name: 'defillama-data',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama data aggregation. Historical TVL trends, protocol comparison analytics, and chain-specific DeFi growth metrics.',
    downloads: 32400,
    stars: 1620,
    version: '1.0.0',
    installCommand: '> install the defillama-data skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-data',
    usageExample: '> get historical TVL\n> compare protocols\n> analyze chain growth',
    detailedDescription: 'DefiLlama historical data aggregation platform. Access historical TVL trends, perform side-by-side protocol comparisons, and analyze chain-specific DeFi ecosystem growth metrics over time.',
    featured: true,
  },
  {
    id: 'defillama-official-chain-ecosystem',
    name: 'defillama-official-chain-ecosystem',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official chain ecosystem analytics. Protocol distribution per chain, ecosystem comparison, and chain-level DeFi health metrics.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the defillama-official-chain-ecosystem skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-chain-ecosystem',
    usageExample: '> analyze chain ecosystem\n> compare ecosystems\n> check chain health',
    detailedDescription: 'Official DefiLlama chain ecosystem analytics. View protocol distribution across individual chains, compare ecosystem maturity and diversity, and assess chain-level DeFi health indicators.',
  },
  {
    id: 'defillama-official-defi-market-overview',
    name: 'defillama-official-defi-market-overview',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official DeFi market overview. Global TVL, sector breakdowns, protocol rankings, and real-time DeFi market pulse.',
    downloads: 34200,
    stars: 1710,
    version: '1.0.0',
    installCommand: '> install the defillama-official-defi-market-overview skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-defi-market-overview',
    usageExample: '> get global TVL\n> view sector breakdown\n> check market pulse',
    detailedDescription: 'Official DefiLlama DeFi market overview dashboard. Monitor global total value locked, explore sector breakdowns by category, view real-time protocol rankings, and track the overall DeFi market pulse.',
    featured: true,
    trending: true,
  },
];